<template>
  <div class="user-list-container">
    <!-- 筛选条件区域 -->
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="4" :colGap="12" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item label="项目编码" label-col-flex="60px">
              <a-input v-model="queryForm.projectCode" placeholder="请输入项目编码" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="项目名称" label-col-flex="60px">
              <a-input v-model="queryForm.projectName" placeholder="请输入项目名称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="项目状态" label-col-flex="60px">
              <a-select v-model="queryForm.projectStatus" placeholder="请选择项目状态" class="input" allow-clear>
                <a-option value="">全部</a-option>
                <a-option :value="1">进行中</a-option>
                <a-option :value="2">已完成</a-option>
                <a-option :value="3">已暂停</a-option>
                <a-option :value="4">已取消</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <div>
              <a-space>
                <a-button type="primary" @click="handleQuery" :loading="loading">
                  <template #icon>
                    <icon-search style="stroke: #fff"/>
                  </template>
                  搜索
                </a-button>
                <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
                <a-button type="text" @click="()=>{collapsed = !collapsed}">
                  <template #icon>
                    <icon-down v-if="collapsed" />
                    <icon-up v-else />
                  </template>
                  {{ collapsed ? '展开' : '收起' }}
                </a-button>
              </a-space>
            </div>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="客户编码" label-col-flex="60px">
              <a-input v-model="queryForm.customerCode" placeholder="请输入客户编码" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="合同开始日期" label-col-flex="100px">
              <a-range-picker v-model="contractStartDateRange" :placeholder="['从','至']" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="合同到期日期" label-col-flex="100px">
              <a-range-picker v-model="contractEndDateRange" :placeholder="['从','至']" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
        </a-grid>
      </a-form>
    </canvas-glass-card>
    <a-space/>
    <!-- 项目管理表格 -->
    <canvas-glass-card variant="primary" :hoverable="false" class="table-card">
      <!-- 标题栏 -->
      <template #header>
        <a-row>
          <a-col flex="200px">
            <span class="glass-card__title">项目列表</span>
          </a-col>
          <a-col flex="auto"/>
        </a-row>
      </template>

      <!-- 项目管理数据表格 -->
      <a-table
          :columns="allColumns"
          :data="pagination.records"
          :pagination="false"
          :loading="loading"
          column-resizable
          stripe
          :bordered="{cell:true}"
          :scroll="{ x: 1000 }"
      >

        <template #projectStatus="{ record }">
          {{ getStatusText(record.projectStatus) }}
        </template>

        <template #contractStartDate="{ record }">
          {{ formatDate(record.contractStartDate) }}
        </template>
        
        <template #contractEndDate="{ record }">
          {{ formatDate(record.contractEndDate) }}
        </template>
        
        <template #createTime="{ record }">
          {{ formatDateTime(record.createTime) }}
        </template>

        <template #updateTime="{ record }">
          {{ formatDateTime(record.updateTime) }}
        </template>
        <!--        TODO 操作列暂时不用-->
        <!--        <template #action="{ record }">-->
        <!--&lt;!&ndash;          <a-space>&ndash;&gt;-->
        <!--            <a-button type="text" size="mini" @click="editCustomer(record)">-->
        <!--              <template #icon>-->
        <!--                <icon-edit/>-->
        <!--              </template>-->
        <!--              编辑-->
        <!--            </a-button>-->
        <!--            <a-popconfirm-->
        <!--                content="确定要删除该客户吗？"-->
        <!--                @ok="deleteCustomer(record)"-->
        <!--                ok-text="确定"-->
        <!--                cancel-text="取消"-->
        <!--            >-->
        <!--              <a-button type="text" size="mini"  status="danger">-->
        <!--                <template #icon>-->
        <!--                  <icon-delete/>-->
        <!--                </template>-->
        <!--                删除-->
        <!--              </a-button>-->
        <!--            </a-popconfirm>-->
        <!--&lt;!&ndash;          </a-space>&ndash;&gt;-->
        <!--        </template>-->
      </a-table>

      <!-- 分页组件 -->
      <a-pagination
          style="justify-content: end;margin: 10px;"
          v-model:current="pagination.current"
          v-model:page-size="pagination.size"
          :total="pagination.total"
          :page-size-options="[10, 20, 50, 100]"
          show-total
          show-jumper
          show-page-size
          @change="handlePageChange"
          @page-size-change="handlePageSizeChange"
      />
    </canvas-glass-card>

  </div>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import {getProjectTaskPage} from '@/apis/work-order-api'
import CanvasGlassCard from '@/components/CanvasGlassCard.vue'
import {
  IconSearch,
  IconDown,
  IconUp,
} from '@arco-design/web-vue/es/icon'
import {Message} from "@arco-design/web-vue";
import {
  dateTimeString2timestampNumber,
  timestampNumber2dateString,
  timestampNumber2datetimeString
} from "@/utils/date-util";

// 条件查询表单折叠
const collapsed = ref(true)

// 条件查询表单数据
// 合同开始日期 范围
const contractStartDateRange = ref( [])
// 合同到期日期 范围
const contractEndDateRange = ref( [])
const queryForm = ref({
  projectCode: '',
  projectName: '',
  customerCode: '',
  projectStatus: '',
  contractStartDateLeftRange: null,
  contractStartDateRightRange: null,
  contractEndDateLeftRange: null,
  contractEndDateRightRange: null,
})

// 项目管理数据
let pagination = ref({
  records: [],
  current: 1,
  size: 10,
  pages: 0,
  total: 0
})
// 加载状态
const loading = ref(false)

// 所有列定义
const allColumns = ref([
  // {title: 'ID', dataIndex: 'id', width: 80, required: true},
  {title: '项目编码', dataIndex: 'projectCode', width: 135, ellipsis: true, tooltip: true, fixed: 'left', required: true},
  {title: '项目名称', dataIndex: 'projectName', width: 300, ellipsis: true, tooltip: true, fixed: 'left', required: true},
  // {title: '所属客户编码', dataIndex: 'customerCode', width: 180, ellipsis: true,tooltip: true},
  {title: '项目状态', dataIndex: 'projectStatus', width: 120, ellipsis: true, tooltip: true, slotName: 'projectStatus',},
  {title: '备注', dataIndex: 'remark', width: 180, ellipsis: true, tooltip: true,},
  {title: '创建时间', dataIndex: 'createTime', width: 160, ellipsis: true, tooltip: true, slotName: 'createTime',},
  {title: '更新时间', dataIndex: 'updateTime', width: 160, ellipsis: true, tooltip: true, slotName: 'updateTime',},
  // TODO 操作列暂时不用
  // {title: '操作', dataIndex: 'action', width: 180, slotName: 'action', fixed: 'right', required: true, align: 'center', cellStyle:{paddingLeft: 0,paddingRight:0}, bodyCellStyle:{paddingLeft: 0,paddingRight:0}}
])

// 获取表格数据
const fetchTableData = () => {
  if (contractStartDateRange.value.length > 0) {
    queryForm.value.contractStartDateLeftRange = dateTimeString2timestampNumber(contractStartDateRange.value[0])
    queryForm.value.contractStartDateRightRange = dateTimeString2timestampNumber(contractStartDateRange.value[1])
  } else {
    queryForm.value.contractStartDateLeftRange = null
    queryForm.value.contractStartDateRightRange = null
  }
  if (contractEndDateRange.value.length > 0) {
    queryForm.value.contractEndDateLeftRange = dateTimeString2timestampNumber(contractEndDateRange.value[0])
    queryForm.value.contractEndDateRightRange = dateTimeString2timestampNumber(contractEndDateRange.value[1])
  } else {
    queryForm.value.contractEndDateLeftRange = null
    queryForm.value.contractEndDateRightRange = null
  }
  loading.value = true;
  getProjectTaskPage({
    ...queryForm.value,
    current: pagination.value.current,
    size: pagination.value.size
  }).then(response => {
    // console.log(response)
    loading.value = false;
    if (response.code === 0) {
      pagination.value = response.data;
      // console.log(pagination.value)
    } else {
      Message.error(response.message);
    }
  }).catch(error => {
    Message.error(error.message)
  })
}

// 处理查询
const handleQuery = () => {
  pagination.current = 1
  fetchTableData()
}

// 重置筛选条件
const handleReset = () => {
  Object.keys(queryForm.value).forEach(key => {
    queryForm.value[key] instanceof Array ? queryForm.value[key].length = 0 : queryForm.value[key] = ''
  })
  contractStartDateRange.value = []
  contractEndDateRange.value = []
  handleQuery()
}

// 处理页码变化
const handlePageChange = (page) => {
  fetchTableData()
}

// 处理每页数量变化
const handlePageSizeChange = (size) => {
  pagination.current = 1
  fetchTableData()
}

// 格式化方法 项目状态：1-进行中，2-已完成，3-已暂停，4-已取消
// TODO 待替换数据字典
const getStatusText = (projectStatus) => {
  const map = {1: '进行中', 2: '已完成', 3: '已暂停', 4: '已取消'}
  return map[projectStatus] || projectStatus || '未知'
}
const formatDate = (dateString) => {
  // if (!dateString) return '-'
  // const date = new Date(dateString)
  // return date.toLocaleString('zh-CN')
  if (!dateString) return '—';
  // return dateString.substring(0, 16).replace('T', ' ');
  return timestampNumber2dateString(dateString)
}
const formatDateTime = (dateString) => {
  // if (!dateString) return '-'
  // const date = new Date(dateString)
  // return date.toLocaleString('zh-CN')
  if (!dateString) return '—';
  // return dateString.substring(0, 16).replace('T', ' ');
  return timestampNumber2datetimeString(dateString)
}

// 组件挂载时获取数据
onMounted(() => {
  fetchTableData()
})
</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}

.glass-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}
</style>